import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#5E376D',
      light: '#5E376D',
      dark: '#5E376D',
    },
    secondary: {
      main: '#64b5f6',
      light: '#9be7ff',
      dark: '#2286c3',
    },
    error: {
      main: red.A400,
    },
  },
  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          color: '#171717', // Set the default text color for unselected tabs
        },
      },
    },
  },
});

export default theme;